export const SESSION_ID_KEY = 'session_id';
